import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Channel, Topic } from "../../../constants";
import { AppFeatures } from "../../../constants/featureFlags";
import { useFeature } from "../../../hooks/useFeature";

import { SettingsActionCreators } from "../../../redux/action-creators";
import { SettingsSelectors } from "../../../redux/selectors";
import { MessageBrokerUtils } from "../../../utils";

export const useOddsSettings = () => {
  const isSettingsEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const oddsSettings = useSelector(SettingsSelectors.odds.settings);

  const dispatch = useDispatch();

  const setOdds = useCallback(
    (data, envelope) => {
      let oddsSetting = null;

      const oddsFormat =
        envelope && envelope.headers.version === 2 && data.oddsFormat
          ? data.oddsFormat
          : data;

      if (oddsFormat)
        oddsSetting = oddsSettings.find(
          oddsSetting => oddsSetting.code === oddsFormat
        );

      dispatch(SettingsActionCreators.odds.setCurrent(oddsSetting));
    },
    [oddsSettings, dispatch]
  );

  useEffect(() => {
    let playerPreferencesSubscription = null;

    if (isSettingsEnabled) {
      playerPreferencesSubscription = MessageBrokerUtils.subscribe({
        channel: Channel.PLAYER,
        topic: Topic.playerPreferences,
        callback: setOdds
      });
    }

    return () => {
      playerPreferencesSubscription?.unsubscribe();
    };
  }, [isSettingsEnabled, setOdds]);
};
